import { Component, OnInit } from '@angular/core';
import { JwtService } from 'src/app/services/jwt.service';
import { ApiService } from 'src/app/services/api.service';
import { ExitService } from 'src/app/services/exit.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css'],
})
export class DashboardComponent implements OnInit {
  menu;
  status;
  submenu: boolean[] = [];

  constructor(
    private jwt: JwtService,
    private api: ApiService,
    private exitService: ExitService
  ) {}

  ngOnInit(): void {
    this.jwt.check();
    if (this.menu == undefined) {
      this.loadData();
    }
  }

  loadData() {
    this.api.menu().subscribe((data) => {
      this.menu = data.data;
      this.pages();
    });
    this.api.config().subscribe((data) => {
      this.status = data;
    });
  }

  pages() {
    let pages = [] as any;
    this.menu.forEach((element) => {
      if (element.submenus.length != 0) {
        element.submenus.forEach((ele) => {
          pages.push(ele.pageID);
        });
      } else {
        pages.push(element.pageID);
      }
    });
    pages.push('aviator');
    pages.push('stroopeffect');
    pages.push('repeatthesound');
    pages.push('2048');
    pages.push('hextris');
    pages.push('jump');
    pages.push('tetris');
    pages.push('8puzzle');
    pages.push('bubbleshooter');
    pages.push('theaviator');
    pages.push('hangman');
    pages.push('jumpsquare');
    pages.push('wordguessing');
    sessionStorage.setItem('pages', JSON.stringify(pages));
  }

  logout() {
    this.exitService.logout();
  }

  checkActive(id: string) {
    return location.pathname.includes(id);
  }
}
